<template>
    <div
        v-if="findings.length > 0"
        data-test="language-findings"
        class="inline-block rounded-md bg-amber-50 border border-amber-100 px-4 py-2 text-sm sm:text-base mt-2 space-y-2"
    >
        <div
            v-for="(finding, index) in findings"
            :key="index"
            class="flex items-start"
        >
            <div class="shrink-0 text-amber-400">
                <LightBulbIcon class="h-5 w-5" aria-hidden="true" />
            </div>
            <div class="ml-3 text-sm text-left text-amber-700">
                <p>
                    Possible issue:
                    <span class="font-medium"
                        >&ldquo;{{ finding.phrase }}&rdquo;</span
                    >
                    - {{ finding.category }}.
                </p>
                <p>{{ finding.suggestion }}</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// The outline set, as in CartItemTips.vue: the solid set has no light bulb.
import { LightBulbIcon } from "@heroicons/vue/outline";
import type { LanguageFinding } from "../../functions/reviewLanguage";

defineProps<{
    findings: LanguageFinding[];
}>();
</script>
